import { useEffect } from 'react';

const ServiceWorkerRegistration = () => {
  useEffect(() => {
    if (typeof window === 'undefined' || !('serviceWorker' in navigator)) {
      return;
    }

    // Register service worker for offline caching
    const registerServiceWorker = async () => {
      try {
        const registration = await navigator.serviceWorker.register('/sw.js', {
          scope: '/'
        });
        
        if (process.env.NODE_ENV === 'development') {
          console.log('Service Worker registered successfully:', registration);
        }

        // Update service worker when new content is available
        registration.addEventListener('updatefound', () => {
          const newWorker = registration.installing;
          if (newWorker) {
            newWorker.addEventListener('statechange', () => {
              if (newWorker.state === 'installed' && navigator.serviceWorker.controller) {
                // New content is available, reload page
                if (process.env.NODE_ENV === 'development') {
                  console.log('New content available, reloading...');
                }
                window.location.reload();
              }
            });
          }
        });
      } catch (error) {
        if (process.env.NODE_ENV === 'development') {
          console.error('Service Worker registration failed:', error);
        }
      }
    };

    // Register after page load to avoid blocking
    if (document.readyState === 'complete') {
      registerServiceWorker();
    } else {
      window.addEventListener('load', registerServiceWorker);
    }

    return () => {
      window.removeEventListener('load', registerServiceWorker);
    };
  }, []);

  return null;
};

export { ServiceWorkerRegistration };